
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Level2} from '../core/Level2';
import {FieldModelLevel2} from '../core/Level2';

/**
 * FeedUpdateLevel2SnapshotNotify struct
 */
class FeedUpdateLevel2SnapshotNotify {
  /**
   * Initialize struct
   * @param {!Map=} level2
   * @constructor
   */
  constructor (level2 = new Map()) {
    this.Level2 = level2
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedUpdateLevel2SnapshotNotify}
   * @param {!FeedUpdateLevel2SnapshotNotify} other Other struct
   * @returns {!FeedUpdateLevel2SnapshotNotify} This struct
   */
  copy (other) {
    if (other.Level2 != null) {
      this.Level2 = new Map()
      Object.keys(other.Level2).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = new UUID(key)
          if (other.Level2[key] != null) {
            let tempValue
            tempValue = Level2.fromObject(other.Level2[key])
            this.Level2.set(tempKey, tempValue)
          } else {
            this.Level2.set(tempKey, null)
          }
        }
      })
    } else {
      this.Level2 = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedUpdateLevel2SnapshotNotify}
   * @returns {!FeedUpdateLevel2SnapshotNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedUpdateLevel2SnapshotNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedUpdateLevel2SnapshotNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedUpdateLevel2SnapshotNotify}
   * @param {!FeedUpdateLevel2SnapshotNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedUpdateLevel2SnapshotNotify)) {
      throw new TypeError('Instance of FeedUpdateLevel2SnapshotNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedUpdateLevel2SnapshotNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Level2: ((this.Level2 != null) ? fbe.MapToObject(new Map(Array.from(this.Level2, item => [((item[0] != null) ? item[0].toString() : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedUpdateLevel2SnapshotNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedUpdateLevel2SnapshotNotify} other Object value
   * @returns {!FeedUpdateLevel2SnapshotNotify} Created struct
   */
  static fromObject (other) {
    return new FeedUpdateLevel2SnapshotNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedUpdateLevel2SnapshotNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedUpdateLevel2SnapshotNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedUpdateLevel2SnapshotNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2062
  }
}

export { FeedUpdateLevel2SnapshotNotify };

/**
 * Fast Binary Encoding FeedUpdateLevel2SnapshotNotify field model
 */
class FieldModelFeedUpdateLevel2SnapshotNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Level2 = new fbe.FieldModelMap(new fbe.FieldModelUUID(buffer, 4 + 4), new FieldModelLevel2(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Level2.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Level2.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedUpdateLevel2SnapshotNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2062
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Level2.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Level2.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!FeedUpdateLevel2SnapshotNotify} fbeValue Default value, defaults is new FeedUpdateLevel2SnapshotNotify()
   * @returns {!FeedUpdateLevel2SnapshotNotify} FeedUpdateLevel2SnapshotNotify value
   */
  get (fbeValue = new FeedUpdateLevel2SnapshotNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!FeedUpdateLevel2SnapshotNotify} fbeValue FeedUpdateLevel2SnapshotNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Level2.fbeSize) <= fbeStructSize) {
      this.Level2.get(fbeValue.Level2)
    } else {
      fbeValue.Level2.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {!FeedUpdateLevel2SnapshotNotify} fbeValue FeedUpdateLevel2SnapshotNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedUpdateLevel2SnapshotNotify}
   * @param {FeedUpdateLevel2SnapshotNotify} fbeValue FeedUpdateLevel2SnapshotNotify value
   */
  setFields (fbeValue) {
    this.Level2.set(fbeValue.Level2)
  }
}

export { FieldModelFeedUpdateLevel2SnapshotNotify };

/**
 * Fast Binary Encoding FeedUpdateLevel2SnapshotNotify model
 */
class FeedUpdateLevel2SnapshotNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedUpdateLevel2SnapshotNotify(this.buffer, 4)
  }

  /**
   * Get the FeedUpdateLevel2SnapshotNotify model
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @returns {!FieldModelFeedUpdateLevel2SnapshotNotify} model FeedUpdateLevel2SnapshotNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedUpdateLevel2SnapshotNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedUpdateLevel2SnapshotNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @param {!FeedUpdateLevel2SnapshotNotify} value FeedUpdateLevel2SnapshotNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @param {!FeedUpdateLevel2SnapshotNotify} value FeedUpdateLevel2SnapshotNotify value, defaults is new FeedUpdateLevel2SnapshotNotify()
   * @return {!object} Deserialized FeedUpdateLevel2SnapshotNotify value and its size
   */
  deserialize (value = new FeedUpdateLevel2SnapshotNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedUpdateLevel2SnapshotNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedUpdateLevel2SnapshotNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedUpdateLevel2SnapshotNotifyModel}
   * @param {!number} prev Previous FeedUpdateLevel2SnapshotNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedUpdateLevel2SnapshotNotifyModel };
